import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box, CssBaseline, CircularProgress } from '@mui/material';
import { AuthContext } from './context/AuthContext';
import RoutesConfig from './routes/RoutesConfig';
import MainLayout from './components/MainLayout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useOrderSocket } from './hooks/useOrderSocket';
import NotificationPermission from './components/NotificationPermission';
import { initializeAudio } from './utils/playNotificationSound';

const App: React.FC = () => {
  const { user, loading } = useContext(AuthContext);

  // Initialize audio when app loads
  useEffect(() => {
    initializeAudio();
  }, []);

  // Always call hook - let it handle conditional logic internally
  useOrderSocket();

  if (loading) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Router>
      <CssBaseline />
        <ToastContainer />
        <NotificationPermission />
        {user ? <MainLayout /> : <RoutesConfig />}
    </Router>
  );
};

export default App;